// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__1kFKD","rootHoverable":"IconButton_rootHoverable__f63gC"};